import React from "react";

const ASP_Cookies = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Cookies</h1>
      <p>This is the ASP Cookies page content.</p>
    </div>
  );
};

export default ASP_Cookies;
